import PageMeta from "components/components/Meta/PageMeta";
import PageHeader from "components/dataVisualization/dataPageComponents/PageHeader/PageHeader";
import React from "react";

const RemitSubmit: React.FC = () => (
  <>
    <PageMeta title="Submit REMIT" />
    <PageHeader
      title="Submit REMIT"
      pageDescription={
        <>
          <p>
            This page will allow market participants to submit REMIT (Regulation
            on wholesale Energy Markets Integrity and Transparency)
            notifications directly through Insights.
          </p>
        </>
      }
    />
  </>
);

export default RemitSubmit;
